var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14.3",
    width: 16,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 13.8A6.7 6.7 0 01.5 7.2 6.7 6.7 0 017.2.5a6.7 6.7 0 016.6 6.7",
    fill: "none",
    stroke: "#b0bbd1",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b0bbd1",
    strokeLinejoin: "round",
    d: "M15.5 3.7L14.1 7l-3.2-1.4"
  })));
}
export default SvgRedo;